import { z } from 'zod';
import { id, paginatedResult, paginationQuery, timestamp } from './common.js';
import { bookingStatus } from './shift.js';

export const bookingMessage = z.object({
  id,
  bookingId: id,
  senderUserId: id,
  senderName: z.string(),
  senderSide: z.enum(['professional', 'office']),
  sequence: z.number().int().positive(),
  body: z.string(),
  createdAt: timestamp,
});
export type BookingMessage = z.infer<typeof bookingMessage>;
export const bookingThread = z.object({
  bookingId: id,
  shiftId: id,
  bookingStatus,
  locationName: z.string(),
  professionalName: z.string(),
  startsAt: timestamp,
  endsAt: timestamp,
  timezone: z.string(),
  callerSide: z.enum(['professional', 'office']),
  canSend: z.boolean(),
  readOnlyReason: z.string().nullable(),
  latestMessage: z.string().nullable(),
  latestMessageAt: timestamp.nullable(),
  lastSequence: z.number().int().nonnegative(),
  unreadCount: z.number().int().nonnegative(),
  counterpartReadThrough: z.number().int().nonnegative(),
});
export type BookingThread = z.infer<typeof bookingThread>;
export const bookingThreadPage = paginatedResult(bookingThread);
export type BookingThreadPage = z.infer<typeof bookingThreadPage>;
export const bookingMessagePage = paginatedResult(bookingMessage).extend({ thread: bookingThread });
export type BookingMessagePage = z.infer<typeof bookingMessagePage>;
export const bookingThreadQuery = paginationQuery.extend({
  unreadOnly: z.enum(['true', 'false']).optional(),
});
export const sendBookingMessageInput = z
  .object({
    clientMessageId: z.string().uuid(),
    body: z.string().trim().min(1).max(4000),
  })
  .strict();
export type SendBookingMessageInput = z.infer<typeof sendBookingMessageInput>;
export const markBookingMessagesReadInput = z
  .object({ sequence: z.number().int().nonnegative() })
  .strict();
